// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { addressProps } from "@store/Themes/common/props/address";
import * as React from "react";
import { connect } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    currentBillTo: getCurrentBillToState(state).value,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export const addressesCustomerNumberStyles = {
    wrapper: addressProps.box,
    headingText: addressProps.title,
};

const styles = addressesCustomerNumberStyles;

const AddressesCustomerNumber: React.FunctionComponent<Props> = (props: Props) => {
    const { currentBillTo } = props;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.headingText}>{translate("Customer Number")}</Typography>
            {!currentBillTo ? <Loader /> : <Typography>{currentBillTo.customerNumber}</Typography>}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(AddressesCustomerNumber),
    definition: {
        group: "Addresses",
        allowedContexts: ["AddressesPage"],
    },
};

export default widgetModule;
